import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { WindowFrame } from '../ui/WindowFrame';
import { WorkflowStepScene } from '../scenes/WorkflowStepScene';
import { researchWorkflow } from '../../data/researchWorkflow';
export function ResearchWorkflow() {
  const [index, setIndex] = useState(0);
  const step = researchWorkflow[index];
  const isLast = index === researchWorkflow.length - 1;
  return <section className="bg-white/50 py-24 md:py-32" data-id="element-48" data-mp="2ynrfzboiv81r">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-49" data-mp="2ym80voelr31k">
        <SectionHeader title="From information to action." body="Follow one research finding from the page it came from to the knowledge map it now belongs to." data-id="element-50" data-mp="2umphix2fj00u" />

        <div className="mt-14 grid gap-10 lg:grid-cols-[minmax(0,380px)_1fr] lg:gap-14" data-id="element-51" data-mp="3mdlv5zwbd8p6">
          <ol className="flex flex-col" aria-label="Research workflow steps" data-id="element-52" data-mp="32klgl4mikax2">
            {researchWorkflow.map((s, i) => {
            const active = i === index;
            return <li key={s.id} data-id="element-53" data-mp="37lj29r6qfn3b" data-mpi={i}>
                  <button type="button" onClick={() => setIndex(i)} aria-current={active ? 'step' : undefined} className="group flex w-full gap-4 py-3.5 text-left" data-id="element-54" data-mp="2svk43of6gbnu">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[12px] font-semibold tabular-nums transition-colors duration-150 ${active ? 'bg-accent text-white shadow-glow' : i < index ? 'bg-accent-soft text-accent-ink' : 'bg-white text-ink-muted ring-1 ring-ink/10'}`} data-id="element-55" data-mp="2jwggc752f830">
                      {i + 1}
                    </span>
                    <span className="flex-1" data-id="element-56" data-mp="d34byjahanfa">
                      <span className={`block text-[17px] font-semibold tracking-tight transition-colors duration-150 ${active ? 'text-ink' : 'text-ink-muted group-hover:text-ink-soft'}`} data-id="element-57" data-mp="bm7c52ubk8az">
                        {s.title}
                      </span>
                      {active ? <span className="mt-1.5 block text-[15px] leading-relaxed text-ink-soft" data-id="element-58" data-mp="1oksk322rsko">{s.body}</span> : null}
                    </span>
                  </button>
                </li>;
          })}
          </ol>

          <div data-id="element-59" data-mp="pdvq7bo4p6ul">
            <WindowFrame title="Research Workspace" context={step.title} bodyClassName="p-4 sm:p-5" data-id="element-60" data-mp="pddk7nbnze9h">
              <div className="h-[440px] sm:h-[400px]" data-id="element-61" data-mp="kmdlccizim4c">
                <AnimatePresence mode="wait" initial={false} data-id="element-62" data-mp="kl2gsahptac6">
                  <motion.div key={step.id} initial={{
                  opacity: 0,
                  y: 8
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -8
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="h-full" data-id="element-63" data-mp="gkscr3dhgtzy">
                    <WorkflowStepScene step={step.id} data-id="element-64" data-mp="2vykqhnb4rzv8" />
                  </motion.div>
                </AnimatePresence>
              </div>
            </WindowFrame>
            <div className="mt-4 flex items-center justify-between" data-id="element-65" data-mp="2zymjz96ppmzf">
              <p className="text-sm text-ink-muted" data-id="element-66" data-mp="350btuli77ulx">
                Step {index + 1} of {researchWorkflow.length}
              </p>
              <button type="button" onClick={() => setIndex(isLast ? 0 : index + 1)} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium text-accent transition-colors duration-150 hover:bg-accent-soft" data-id="element-67" data-mp="39y3m5gmr9iqn">
                {isLast ? 'Start again' : 'Next step'}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-68" data-mp="3spmn7hx7ymq1" />
              </button>
            </div>
          </div>
        </div>

        <p className="mt-16 max-w-2xl border-t border-ink/[0.08] pt-8 text-[15px] leading-relaxed text-ink-soft" data-id="element-69" data-mp="1itl8bulqjkg">
          Other workspaces follow their own task-specific workflows—a referral in Government, feedback in Education, a
          supervised review in Clinical—all supported by the same shared environment.{' '}
          <Link to="/workspaces" className="font-medium text-accent hover:text-accent-ink" data-id="element-70" data-mp="3orxpeghuf6vm">
            See every workflow
          </Link>
        </p>
      </div>
    </section>;
}